module.exports = {"530924101":"凤尾镇","530924102":"勐捧镇","530924103":"南伞镇","530924201":"忙丙乡","530924202":"勐堆乡","530924204":"木场乡","530924205":"军赛佤族拉祜族傈僳族德昂族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530924.json
// module id = 2745
// module chunks = 0